import { DeliveryOrderCreatePage } from "@/features/delivery-order/pages/DeliveryOrderCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/admin/delivery-order/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["delivery_order.generate"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: DeliveryOrderCreatePage,
  validateSearch: z.object({
    transferOrderID: z.string(),
  }),
});
